import { render, staticRenderFns } from "./cursorMusic.vue?vue&type=template&id=4620f860&scoped=true&"
import script from "./cursorMusic.vue?vue&type=script&lang=js&"
export * from "./cursorMusic.vue?vue&type=script&lang=js&"
import style0 from "./cursorMusic.vue?vue&type=style&index=0&id=4620f860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620f860",
  null
  
)

export default component.exports